<template>
  <el-dialog :visible="visible" width="800px" @close="close" title="用户收获地址" custom-class="customModal">
    <div class="container">
      <div v-for="item in list" :key="item.address_id" class="listItem">
        <div class="icon"><i class="fa fa-map fa-2x"></i></div>
        <div class="name">
          <label>{{item.consignee}}</label>
          <label>{{item.zipcode}}</label>
        </div>
        <div class="address">
          <label>{{item.mobile}}</label>
          <label>{{item.address}}</label>
        </div>
      </div>
    </div>
    <AppButton type="primary" @click="close" size="small">返回用户列表</AppButton>
  </el-dialog>
</template>

<script>
import { UserService } from '../../service/user.service';
export default {
	name: 'receivingAddress',
	data() {
		return {
      visible: false,
      list: [],
		}
	},
	methods: {
		async open(data) {
      const list = await UserService.receiveAddress(data.user_id);
      this.list = list;
      this.visible = true;
		},
		close() {
			this.visible = false;
		}
	},
}
</script>

<style lang="scss" scoped>

.container {
  height: 400px;
}
.listItem {
  height: 45px;
  width: 100%;
  margin: 8px 0;
  display: flex;
  border: 1px solid #ddd;
  align-items: center;
  .icon {
    width: 100px;
    margin-right: 20px;
  }
  .name {
    width: 160px;
    display: flex;
    flex-direction: column;
  }
  .address {
    display: flex;
    flex-direction: column;
  }
}
</style>